export default [{
    path: '/',
    name: 'home',
    component: () => import('@/pages/v2/home'),
},
{
    path: '/futures/app-download',
    name: 'app-download',
    component: () => import('@/pages/v2/download/app-download'),
},
// {
//     path: '/front/index',
//     name: 'home',
//     component: () => import('@/pages/index/index3'),
//     meta: meta
// }
];



// WEBPACK FOOTER //
// ./src/router/home.js